import { render, staticRenderFns } from "./teamList.vue?vue&type=template&id=acd2f52a"
import script from "./teamList.vue?vue&type=script&lang=js"
export * from "./teamList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports